// extracted by mini-css-extract-plugin
module.exports = {"slider":"Handle--slider--qH0x_"};